import { render, staticRenderFns } from "./StoredValueLedgers.vue?vue&type=template&id=b8bb64d0&scoped=true"
import script from "./StoredValueLedgers.vue?vue&type=script&lang=js"
export * from "./StoredValueLedgers.vue?vue&type=script&lang=js"
import style0 from "./StoredValueLedgers.vue?vue&type=style&index=0&id=b8bb64d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bb64d0",
  null
  
)

export default component.exports